import { ReactElement } from 'react'
import { FuelCard, FuelIcon, FuelTooltip, FuelTypography } from '@frete.com/fuel-react'
import { Props } from './interfaces'
import * as Styled from './styled'
import { Text } from '~constants/text'
import { useTranslator } from '~hooks'
import { FuelFlex } from '@frete.com/fuel-station-react'
import { Skeleton } from '~components/Skeleton/styled'

const Dashboard = ({
  comboName,
  isComboComplete,
  consumed,
  limit,
  initial,
  extras = 0,
  getProduct,
}: Props): ReactElement => {
  const { translate } = useTranslator()

  const CardCompleteUsers = () => {
    return (
      <FuelCard style={{ width: '291px' }} data-testid="card-premium-users">
        <Styled.ContentCard slot="content">
          <FuelFlex defaultProps={{ justifyContent: 'space-between', width: '100%' }}>
            <FuelTypography color="neutral-default" weight="bold" size="caption">
              {translate(Text.REGISTERED_USERS)}
            </FuelTypography>

            <FuelTooltip label={getProduct('user')?.tooltip} placement="bottom">
              <FuelIcon name="information" />
            </FuelTooltip>
          </FuelFlex>

          <Styled.HighlightedContent>
            <FuelTypography color="neutral-strong" size="heading-md" weight="bold">
              {consumed} {translate(Text.OF)} {limit} {translate(Text.REGISTERED_USERS)}
            </FuelTypography>
          </Styled.HighlightedContent>

          <FuelTypography color="neutral-default" weight="bold" size="caption" data-testid="user-price">
            {initial} {translate(Text.FROM)} {translate(Text.PLAN)} / {extras}
            {translate(Text.EXTRA, { plural: extras > 1 ? 's' : '' })}
          </FuelTypography>
        </Styled.ContentCard>
      </FuelCard>
    )
  }

  const CardUsers = () => {
    return (
      <FuelCard style={{ display: 'flex' }} data-testid="card-users">
        <Styled.ContentCard slot="content">
          <FuelTypography color="neutral-default" weight="bold" size="caption">
            {translate(Text.REGISTERED_USERS)}
          </FuelTypography>
          <Styled.HighlightedContent>
            <FuelTypography color="neutral-strong" size="heading-md" weight="bold">
              {consumed}
            </FuelTypography>
            <FuelTypography color="neutral-strong" size="heading-md">
              {` ${translate(Text.OF)} ${limit}`}
            </FuelTypography>
          </Styled.HighlightedContent>
        </Styled.ContentCard>
      </FuelCard>
    )
  }

  return (
    <Styled.CardRow data-testid="dashboard">
      <FuelCard style={{ width: 350 }}>
        <Styled.ContentCard slot="content">
          <FuelTypography color="neutral-default" weight="bold" size="caption">
            {translate(Text.YOUR_PLAN)}
          </FuelTypography>

          <FuelTypography color="neutral-strong" size="heading-md" weight="bold">
            {comboName}
          </FuelTypography>
        </Styled.ContentCard>
      </FuelCard>

      {comboName ? (
        isComboComplete ? (
          <CardCompleteUsers />
        ) : (
          <CardUsers />
        )
      ) : (
        <Skeleton $border="large" $height="142px" $width="291px" />
      )}
    </Styled.CardRow>
  )
}

export default Dashboard
